export default __webpack_public_path__ + "static/media/uiux-bg.060d38f6.jpg";